import { ActionIcon, Menu } from '@mantine/core';
import { IconDotsVertical, IconExternalLink } from '@tabler/icons-react';
import React from 'react';

const DetailMenu = ({ onClick }) => {

	return (
		<Menu
			shadow="md"
			position="bottom-end"
			withinPortal
			withArrow
			arrowOffset={8}
			offset={4}
		>
			{/* Opener */}
			<Menu.Target>
				{/* Icon */}
				<ActionIcon variant="white">
					<IconDotsVertical
						stroke={2}
						size={16}
					/>
				</ActionIcon>
			</Menu.Target>
			{/* Content */}
			<Menu.Dropdown>
				{/* Details */}
				<Menu.Item
					icon={<IconExternalLink size={14} stroke={1.7} />}
					onClick={onClick}
				>
					Detalle
				</Menu.Item>
			</Menu.Dropdown>
		</Menu>
	);

}

export default DetailMenu;
